import { render, staticRenderFns } from "./tags-nav.vue?vue&type=template&id=7ef4abe8"
import script from "./tags-nav.vue?vue&type=script&lang=js"
export * from "./tags-nav.vue?vue&type=script&lang=js"
import style0 from "./tags-nav.vue?vue&type=style&index=0&id=7ef4abe8&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ef4abe8')) {
      api.createRecord('7ef4abe8', component.options)
    } else {
      api.reload('7ef4abe8', component.options)
    }
    module.hot.accept("./tags-nav.vue?vue&type=template&id=7ef4abe8", function () {
      api.rerender('7ef4abe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/components/tags-nav/tags-nav.vue"
export default component.exports